import { useWebSocketData } from '../context/WebSocketContext';
import './Logs.css';

function DeploymentLogs({ domain }) {

  const { deployments } = useWebSocketData();


  return (
    <div className="log-container">
      <ul className="list-unstyled mb-0 fs-8">
        {deployments && deployments.filter(log => domain && log.domain === domain).length > 0 ? deployments.filter(log => domain && log.domain === domain).map((log, idx) => (
          <li key={idx} style={{ color: log.type === 'error' ? 'red' : 'black', fontFamily: 'monospace' }}>
            {log.domain}: [{new Date(log.timestamp).toLocaleTimeString()}] {log.message}
          </li>
        )) : <div>Live logs not found</div>}
      </ul>
    </div>
  );
}

export default DeploymentLogs;
